export default __webpack_public_path__ + "static/property-img3-1ed71c6e4cd5d311bbba7d0b17339a60.jpg";